// Frisian translations
export const fy: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Klanten',
  'menu.products': 'Produkten',
  'menu.users': 'Brûkers',
  'menu.settings': 'Ynstellings',
  'menu.logout': 'Ofmelde',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Nije bestelling',
  'order.title': 'Nije bestelling',
  'order.customer': 'Klant',
  'order.products': 'Produkten',
  'order.total': 'Totaal',
  'users.title': 'Brûkers',
  'users.name': 'Namme',
  'users.email': 'E-post',
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.cancel': 'Annulearje',
  'common.save': 'Bewarje',
  'common.search': 'Sykje',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Oanmelde',
  'login.welcome': 'Wolkom, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-post',
  'signup.phone': 'Telefoan',
  'menu.reportsAndAccounting': 'Rapporten & Boekhâlding',
  'menu.systemAndCommunication': 'Systeem & Kommunikaasje',
};